export default __webpack_public_path__ + "static/media/cover.40beefe3.png";